// extracted by mini-css-extract-plugin
export default {"navBar":"mobile_bottommenu_navBar__-PLji","individualButton":"mobile_bottommenu_individualButton__dKQOn"};